import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    username: "",
    roles: [],
    permission: [],
    designatedSuperAdmin: false,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERNAME: (state, username) => {
    state.username = username;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSION: (state, permission) => {
    state.permission = permission;
  },
  SET_DESIGNATED_SUPER_ADMIN: (state, designatedSuperAdmin) => {
    state.designatedSuperAdmin = designatedSuperAdmin;
  },
};

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { tell, smsNo, smsCode } = userInfo;
    return new Promise((resolve, reject) => {
      login({ tell: tell, smsNo: smsNo, smsCode: smsCode })
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((response) => {
          const { data } = response;
          if (!data) {
            return reject("验证失败，请重新登录");
          }
          const {
            account,
            menus,
            roles = [],
            designatedSuperAdmin = false,
          } = data;
          const permission = [];
          for (const menu of menus) {
            permission.push(menu.path);
          }

          commit("SET_PERMISSION", permission);
          commit("SET_USERNAME", account);
          commit("SET_ROLES", roles);
          // 短信登录场景下 account 可能是手机号，受限页面必须使用后端计算的授权结果。
          commit("SET_DESIGNATED_SUPER_ADMIN", designatedSuperAdmin === true);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 退出登录
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          removeToken();
          resetRouter();
          commit("RESET_STATE");
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 移除 token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken();
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
